"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var react_toastify_1 = require("react-toastify");
var ACWrapperContext_1 = require("../Components/ACWrapperContext");
var helpers_1 = require("./helpers");
var isTruthy = function (value) { return Boolean(value); };
function debounce(fn, delay) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(void 0, args);
        }, delay);
    };
}
var evaluateConditionTree = function (_a) {
    var node = _a.node, store = _a.store;
    if ((node === null || node === void 0 ? void 0 : node.type) === 'condition') {
        var val = helpers_1.Helper.getNestedValue(store, node === null || node === void 0 ? void 0 : node.key);
        switch (node === null || node === void 0 ? void 0 : node.operator) {
            case 'notEquals':
                return val !== (node === null || node === void 0 ? void 0 : node.value);
            case 'truthy':
                return isTruthy(val);
            default:
                return false;
        }
    }
    if ((node === null || node === void 0 ? void 0 : node.type) === 'group') {
        console.log(node, store);
        var results = node === null || node === void 0 ? void 0 : node.conditions.map(function (child) {
            return evaluateConditionTree({ node: child, store: store });
        });
        return (node === null || node === void 0 ? void 0 : node.operator) === 'AND'
            ? results.every(Boolean)
            : results.some(Boolean);
    }
    return true;
};
var formatCurrency = function (amount) {
    var _a, _b;
    return (_b = (_a = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
    })) === null || _a === void 0 ? void 0 : _a.format(amount || 0)) === null || _b === void 0 ? void 0 : _b.replace('₹', '₹ ');
};
var setPrefix = function (_a) {
    var _b, _c;
    var text = _a.text, prefix = _a.prefix;
    return !((_b = text === null || text === void 0 ? void 0 : text.toLowerCase()) === null || _b === void 0 ? void 0 : _b.startsWith(prefix === null || prefix === void 0 ? void 0 : prefix.toLowerCase())) && (text === null || text === void 0 ? void 0 : text.trim()) !== '--' ? (_c = "".concat(prefix, " ").concat(text)) === null || _c === void 0 ? void 0 : _c.trim() : text;
};
var setSuffix = function (_a) {
    var _b, _c;
    var text = _a.text, suffix = _a.suffix;
    text = [null, undefined, ''].includes(text) ? '' : text === null || text === void 0 ? void 0 : text.toString();
    return !((_b = text === null || text === void 0 ? void 0 : text.toLowerCase()) === null || _b === void 0 ? void 0 : _b.endsWith(suffix === null || suffix === void 0 ? void 0 : suffix.toLowerCase())) && (text === null || text === void 0 ? void 0 : text.trim()) !== '--' ? (_c = "".concat(text, " ").concat(suffix)) === null || _c === void 0 ? void 0 : _c.trim() : text;
};
var processLabel = function (elementProps, context, rootState) {
    var _a, _b, _c, _d;
    console.log('process label called', context, rootState, elementProps);
    // If label is a string, return it as is
    if (typeof elementProps.label === 'string') {
        return elementProps.label;
    }
    // If there's a template in the label object
    if ((_a = elementProps === null || elementProps === void 0 ? void 0 : elementProps.label) === null || _a === void 0 ? void 0 : _a.template) {
        var template = elementProps.label.template;
        // Replace ${variable} patterns with values from the state
        return template.replace(/\${([^}]+)}/g, function (match, path) {
            var _a, _b;
            // Get the value from state using the nested path
            var value = helpers_1.Helper.getNestedValue((_b = (_a = context.state) === null || _a === void 0 ? void 0 : _a.dynamic) === null || _b === void 0 ? void 0 : _b[rootState || ''], path);
            // Return the value if found, otherwise use default or the match
            return value !== undefined
                ? String(value)
                : typeof elementProps.label === 'object' &&
                    'default' in elementProps.label
                    ? String(elementProps.label.default)
                    : match;
        });
    }
    // For backward compatibility
    if ((_b = elementProps.label) === null || _b === void 0 ? void 0 : _b.storedLocation) {
        var value = helpers_1.Helper.getNestedValue((_d = (_c = context.state) === null || _c === void 0 ? void 0 : _c.dynamic) === null || _d === void 0 ? void 0 : _d[rootState || ''], elementProps.label.storedLocation);
        return value !== undefined
            ? String(value)
            : typeof elementProps.label === 'object' &&
                'default' in elementProps.label
                ? String(elementProps.label.default)
                : '';
    }
    // Fallback to the original label - convert to string if it's an object
    if (typeof elementProps.label === 'object' && elementProps.label !== null) {
        return elementProps.label.default ? String(elementProps.label.default) : '';
    }
    return elementProps.label || '';
};
var getParamFromPath = function (pattern, key) {
    var pathParts = window.location.pathname.split('/').filter(Boolean);
    var patternParts = pattern.split('/').filter(Boolean);
    for (var i = 0; i < patternParts.length; i++) {
        var part = patternParts[i];
        if (part.startsWith(':')) {
            var paramKey = part.slice(1);
            if (paramKey === key) {
                return pathParts[i] || null;
            }
        }
    }
    return null;
};
var getProcessedLabel = function (elementProps, context, rootState) {
    // First process the label using dynamic state values
    var processedLabel = processLabel(elementProps, context, rootState);
    // Then handle special cases like HTML images
    return processedLabel;
};
var getProcessedEndpoint = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var store, state, _i, _c, _d, key, param, processedParam;
    var _e, _f, _g;
    var params = _b.params, endPoint = _b.endPoint, rootState = _b.rootState;
    return __generator(this, function (_h) {
        store = (0, ACWrapperContext_1.getStore)();
        state = store === null || store === void 0 ? void 0 : store.getState();
        if (params) {
            try {
                for (_i = 0, _c = Object.entries(params); _i < _c.length; _i++) {
                    _d = _c[_i], key = _d[0], param = _d[1];
                    processedParam = param;
                    if (typeof processedParam === 'object') {
                        processedParam = helpers_1.Helper.getNestedValue((_e = state === null || state === void 0 ? void 0 : state.dynamic) === null || _e === void 0 ? void 0 : _e[rootState || ''], (_f = processedParam === null || processedParam === void 0 ? void 0 : processedParam.args) === null || _f === void 0 ? void 0 : _f.storedLocation);
                    }
                    else if (processedParam === null || processedParam === void 0 ? void 0 : processedParam.includes('@state')) {
                        processedParam = helpers_1.Helper.getNestedValue((_g = state === null || state === void 0 ? void 0 : state.dynamic) === null || _g === void 0 ? void 0 : _g[rootState || ''], processedParam.replace('@state', rootState));
                    }
                    // endPoint = processedParam
                    //   ? endPoint.replace(`\${${key}}`, processedParam)
                    //   : endPoint;
                    endPoint = endPoint.replace("${".concat(key, "}"), processedParam);
                }
                return [2 /*return*/, endPoint];
            }
            catch (error) {
                console.error('makeApiCall: Error processing URL parameters:', error);
                react_toastify_1.toast.error('An error occurred. Please contact the administrator.');
                return [2 /*return*/, null];
            }
        }
        return [2 /*return*/];
    });
}); };
var initials = function (text) {
    var textArray = text === null || text === void 0 ? void 0 : text.trim().split(' ');
    if (textArray && textArray.length === 1) {
        return textArray[0][0];
    }
    else if (textArray && textArray.length > 1) {
        return textArray[0][0].concat(textArray[textArray.length - 1][0].toUpperCase());
    }
};
var stringToColour = function (str) {
    if (str === void 0) { str = ''; }
    var hash = 0;
    for (var i = 0; i < (str === null || str === void 0 ? void 0 : str.length); i++) {
        hash = (str === null || str === void 0 ? void 0 : str.charCodeAt(i)) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        var smoothValue = Math.floor((value + 128) / 2);
        colour += ('00' + smoothValue.toString(16)).substr(-2);
    }
    return colour;
};
exports.Utils = {
    debounce: debounce,
    evaluateConditionTree: evaluateConditionTree,
    formatCurrency: formatCurrency,
    getParamFromPath: getParamFromPath,
    getProcessedEndpoint: getProcessedEndpoint,
    getProcessedLabel: getProcessedLabel,
    initials: initials,
    setPrefix: setPrefix,
    setSuffix: setSuffix,
    stringToColour: stringToColour,
};
